module.exports = __webpack_public_path__ + "img/conn1.a807172d.png";